if (!customElements.get('product-selling-plans')) {
  customElements.define(
    'product-selling-plans',
    class ProductSellingPlans extends HTMLElement {
      constructor() {
        super();

        this.section = this.dataset.id;
        this.sellingPlanHiddenClass = 'selling_plan_theme_integration--hidden';

        this.listenToSellingPlanChange();

        this.addToCartForm = document.querySelector('form[data-type="add-to-cart-form"]');
        this.sellingPlanInput = this.querySelector('input[name="selling_plan"]');

        this.planSelectors = Array.from(this.querySelectorAll('input[type="radio"]'));
        this.selectedPlanInput = '';
        this.currentSelectedVariantId = this.addToCartForm.querySelector('input[name="id"]').value;
        this.visibleSellingPlanForm = this.querySelector(`section[data-variant-id="${this.currentSelectedVariantId}"]`);
      }

      variantIdChangedUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;

      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'radio-select') {
            console.log(event.currentPlanName);

            this.setInputPlanId(event.currentPlanName);

            const cartSubscriptionItems = document.querySelector('#CartSubsriptionItems');
            const currentSubscriptionPlan = cartSubscriptionItems.querySelector(
              'mcp-radio-select input[type="radio"]:checked'
            );

            if (this.addToCartForm.querySelector('input[name="selling_plan"]'))
              this.addToCartForm.querySelector('input[name="selling_plan"]').remove();

            if (
              this.visibleSellingPlanForm?.querySelector('input[type="radio"]:checked').dataset.radioType ===
              'selling_plan'
            ) {
              this.addToCartForm.appendChild(this.sellingPlanInput.cloneNode());
            }
          }
        });

        this.planSelectors.forEach((radio) => {
          radio.addEventListener('change', this.listenToSellingPlanChange.bind(this));
        });

        // Frequency dropdown listener
        this.querySelectorAll('.js-sp-frequency').forEach((select) => {
          select.addEventListener('change', this.handleFrequencyChange.bind(this));
        });
      }

      handleFrequencyChange(event) {
        const select = event.target;
        const option = select.selectedOptions[0];
        const planId = option.value;

        // Update hidden selling_plan input
        this.sellingPlanInput.value = planId;
        const formInput = this.addToCartForm.querySelector('input[name="selling_plan"]');
        if (formInput) formInput.value = planId;

        // Update the radio input data attributes
        const card = select.closest('.sp-card');
        const radioInput = card.querySelector('input[type="radio"]');
        if (radioInput) {
          radioInput.dataset.sellingPlanId = planId;
          radioInput.dataset.variantPrice = option.dataset.planPrice;
          radioInput.dataset.variantCompareAtPrice = option.dataset.planCompare;
        }

        // Update displayed prices on the card header
        const priceEl = card.querySelector('.sp-card__price');
        if (priceEl) priceEl.textContent = option.dataset.planPrice;
        const compareEl = card.querySelector('.sp-card__compare');
        if (compareEl) compareEl.textContent = option.dataset.planCompare;

        // Update add-to-cart button price
        if (radioInput) this.updateAddToCartButton(radioInput);
      }

      disconnectedCallback() {
        if (this.variantIdChangedUnsubscriber) {
          this.variantIdChangedUnsubscriber();
        }
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      setInputPlanId(currentPlanName) {
        let productPlans = JSON.parse(
          document.querySelector('script[type="application/ld+json"]#productSellingPlans').innerHTML
        );
        let currentPlan = productPlans.selling_plans.find((sellingPlan) => sellingPlan.name === currentPlanName);
        if (currentPlan) this.sellingPlanInput.value = currentPlan.id;
      }

      listenToSellingPlanChange(event) {
        if (!event) return;

        this.selectedPlanInput = event.target;
        this.updateAddToCartButton(this.selectedPlanInput);

        this.currentSelectors = this.planSelectors.filter(
          (selector) => selector.dataset.radioType === event.target.dataset.radioType
        );
        this.currentSelectors.forEach((selector) => (selector.checked = true));
        if (event.target.dataset.radioType === 'selling_plan') {
          const cartSubscriptionItems = document.querySelector('#CartSubsriptionItems');
          if (cartSubscriptionItems) {
            const currentSubscriptionPlan = cartSubscriptionItems.querySelector(
              'mcp-radio-select input[type="radio"]:checked'
            );
            this.setInputPlanId(currentSubscriptionPlan.value);
          }
          this.addToCartForm.appendChild(this.sellingPlanInput.cloneNode());
        } else {
          this.addToCartForm.querySelector('input[name="selling_plan"]').remove();
        }
      }

      updateAddToCartButton(plan) {
        let selectedPurchaseOptionPrice = plan.dataset.variantPrice;
        let addToCartPrice = document.querySelector(`#price-${this.section}`);
        addToCartPrice.innerText = selectedPurchaseOptionPrice;
      }

      /*
        Each product variant comes with a selling plan selection box that the buyer can interact with.
        When a buyer chooses a different variant, we ensure that only the relevant selling plan selection box is displayed.
        This guarantees that only the selling plan associated with the selected variant is shown.
      */
      handleVariantChange(event) {
        if (!event.data.variant) return;
        console.log('VARIANT DATA CHANGE', event.data.variant.id.toString());
        let selectedVariantId = event.data.variant.id.toString();

        // 41152088735825  41152088768593
        const sellingPlanFormForSelectedVariant = this.querySelector(`section[data-variant-id="${selectedVariantId}"]`);
        const sellingPlanFormsForUnselectedVariants = this.querySelectorAll(
          `.selling_plan_theme_integration:not([data-variant-id="${selectedVariantId}"])`
        );

        this.visibleSellingPlanForm = sellingPlanFormForSelectedVariant;

        console.log('sellingPlanFormForSelectedVariant', sellingPlanFormForSelectedVariant);
        this.selectedPlanInput = sellingPlanFormForSelectedVariant.querySelector('input[type="radio"]:checked');
        this.updateAddToCartButton(this.selectedPlanInput);

        this.showSellingPlanForm(sellingPlanFormForSelectedVariant);
        this.hideSellingPlanForms(sellingPlanFormsForUnselectedVariants);
      }

      showSellingPlanForm(sellingPlanFormForSelectedVariant) {
        sellingPlanFormForSelectedVariant?.classList?.remove(this.sellingPlanHiddenClass);
      }

      hideSellingPlanForms(sellingPlanFormsForUnselectedVariants) {
        sellingPlanFormsForUnselectedVariants.forEach((element) => {
          element.classList.add(this.sellingPlanHiddenClass);
        });
      }
    }
  );
}

// MCP added for quick add
if (document.querySelector('quick-add-selling-plans')) {
  console.log('QUICK SELLING PLANS INTEGRATIONS JS LOADED', document.querySelector('quick-add-selling-plans'));

  const subscriptionInputs = document.querySelectorAll('input[name="selling_plan"]');

  console.log('subscriptionInputs', subscriptionInputs);

  if (subscriptionInputs) {
    let cartUpdateUnsubscriber = undefined;

    cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      console.log('EVENT', event);
      console.log('EVENT_SOURCE', event.source);
      if (event.source === 'radio-select') {
        updateInputSellingPlanValue(event.currentPlanName);
      }
    });

    const getCurrentPlanValue = (variantId) => {
      const cartSubscriptionItems = document.querySelector('#CartSubsriptionItems');
      if (cartSubscriptionItems) {
        const currentSubscriptionPlan = cartSubscriptionItems.querySelector(
          'mcp-radio-select input[type="radio"]:checked'
        );
        console.log('SUBSCRIPTIONS_IN_CART', currentSubscriptionPlan.value);
        let currentSubscriptionPlanValue = currentSubscriptionPlan.value;
        return currentSubscriptionPlanValue;
      } else {
        if (variantId) {
          variantPlans = JSON.parse(
            document.querySelector(`script[type="application/ld+json"]#variantSellingPlans-${variantId}`).innerHTML
          );
        } else {
          variantPlans = JSON.parse(
            document.querySelector('script[type="application/ld+json"]#variantSellingPlans').innerHTML
          );
        }
        console.log('PLANS', variantPlans);
        variantPlanName = variantPlans.selling_plans[0].name;
        console.log('productPlanName', variantPlanName);
        return variantPlanName;
      }
    };

    const updateInputSellingPlanValue = (currentPlanName) => {
      subscriptionInputs.forEach((input) => {
        let variantId = input.dataset?.id;
        if (!currentPlanName) currentPlanName = getCurrentPlanValue(variantId);

        let variantPlans = [];
        if (variantId) {
          variantPlans = JSON.parse(
            document.querySelector(`script[type="application/ld+json"]#variantSellingPlans-${variantId}`).innerHTML
          );
        }
        console.log('PLANS', variantPlans);
        variantPlan = variantPlans.selling_plans.find((sellingPlan) => sellingPlan.name === currentPlanName);
        console.log('variantPlan', variantPlan);
        if (variantPlan) input.value = variantPlan.id;
      });
    };

    updateInputSellingPlanValue();
  }
}
